import { render, staticRenderFns } from "./bindmobiledialog.vue?vue&type=template&id=46dd1be2&scoped=true"
import script from "./bindmobiledialog.vue?vue&type=script&lang=js"
export * from "./bindmobiledialog.vue?vue&type=script&lang=js"
import style0 from "./bindmobiledialog.vue?vue&type=style&index=0&id=46dd1be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd1be2",
  null
  
)

export default component.exports